<template>
<div class="history">

    <v-timeline dense>

      <v-timeline-item small v-for="event in events" :key="event.date" :color="event.color">

        <v-layout row>
        <v-flex>

        <v-card class="mr-2">
            <v-card-title>
              <div>
               <div class="headline">{{ event.title }}</div>
               <span class="gery--text">{{ event.date }}</span>
              </div>
            </v-card-title>

            <v-card-text>
               {{ event.text }}
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn outline :color="event.buttoncolor" :href="event.link">{{ event.buttonMessage }}</v-btn>
            </v-card-actions>

         </v-card>

        </v-flex>
        </v-layout>
      </v-timeline-item>

    </v-timeline>
    
</div>
</template>
<script>
export default {
  data() {
        return{
            events: [
                { date: '2019.05.13', title: 'v-sendai meetup #1', text: '記念すべき第1回を開催しました。月曜開催にも関わらずたくさんの人が参加してくれました。', color: 'blue', link:'https://v-sendai.connpass.com/event/127573/', buttoncolor:'pink', buttonMessage:'イベントページを見る' },
                { date: '2019.07.01', title: 'v-sendai meetup #2', text: '第1回の参加者が多かったので、大きい会場に変更。それでも補欠者が出てしまうほど、たくさんの人に参加いただきました！', color: 'blue', link:'https://v-sendai.connpass.com/event/132973/', buttoncolor:'pink', buttonMessage:'イベントページを見る' },
                { date: '未定（9月ごろ予定）', title: 'v-sendai meetup #3', text: '第3回目の開催は未定です。セッション・LT募集中なので、皆さまの登壇をお待ちしています！', color: 'white', link:'', buttoncolor:'grey', buttonMessage:'準備中です'}
            ]
        }
    }
}
</script>

